import initContainer from '@99designs/brand-container/index';
import relativeTime from '@99designs/brand-container/lib/ui/relative-time';
import $ from 'jquery';
import { assign } from 'lodash';

//
// Initialise platform services
//
export default function initialise() {
    if (!document.querySelector('[data-globalnavui]')) {
        return;
    }

    const options = $('[data-globalnavui]').data();

    initContainer();
    relativeTime.attachTo('html');
}



// WEBPACK FOOTER //
// ./js/common/components/globalNav.js